import React from 'react';
import block from 'bem-cn-lite';
import CursorTooltip from '../../Components/CursorTooltip/index';
import { I18n } from 'react-i18next';

class TextArea extends React.Component {
    getCursorPosition(event) {
        const {x, y} = this.getTextAreaPosition();

        return {
            x: event.nativeEvent.clientX - x,
            y: event.nativeEvent.clientY - y,
        }
    }

    getTextAreaPosition() {
        const rect = this.textArea.getBoundingClientRect();

        return {
            x: rect.left,
            y: rect.top
        }
    }

    mouseMoveHandler = (event) => {
        const {isDisabled} = this.props;

        if (isDisabled) {
            return false;
        }

        const cursorPosition = this.getCursorPosition(event);
        this.showCursorTooltip(cursorPosition);
    }

    mouseLeaveHandler = () => {
        if (this.cursorTooltip) {
            this.cursorTooltip.style.visibility = 'hidden';
        }
    }

    showCursorTooltip({x, y}) {
        if (this.cursorTooltip) {
            this.cursorTooltip.style.top = `${y}px`;
            this.cursorTooltip.style.left = `${x}px`;
            this.cursorTooltip.style.visibility = 'visible';
        }
    }

    highlightRange = (range) => {
        const newNode = document.createElement("span");

        newNode.className = 'highlighted';
        range.surroundContents(newNode);
    }

    highlightSelection = () => {
        const selection = window.getSelection();
        const range = selection.getRangeAt(0)
        const text = selection.toString();

        const {onSelect} = this.props;

        if (!text.trim()) {
            return false;
        }

        this.highlightRange(range);

        onSelect();
    }

    onMouseDownHandler = (event) => {
        const {isCommenting, isDisabled} = this.props;

        if (isCommenting || isDisabled) {
            event.preventDefault();
            return false;
        }
    }

    render() {
        const b = block('TextArea');

        const {isSelectedOnce, isCommenting, text} = this.props;

        return (
            <I18n ns={ ['documentProofing'] }>
            {
                (t) => (
                    <div
                        className={b()}
                        onMouseMove={this.mouseMoveHandler}
                        onMouseLeave={this.mouseLeaveHandler}
                        ref={(ref) => this.textArea = ref}>

                        {
                            !isSelectedOnce &&
                            <div className={b('tooltip')}>
                                {t('documentProofing:tooltip')}
                            </div>
                        }

                        {
                            !isCommenting &&
                            <CursorTooltip
                                cursorTooltipRef={(ref) => this.cursorTooltip = ref}
                                tooltipTextKey='select'/>
                        }

                        <div
                            className={b('content')}>
                            <p
                                className={b('text', {selected: isSelectedOnce})}
                                onMouseDown={this.onMouseDownHandler}
                                onMouseUp={this.highlightSelection}>
                                {text}
                            </p>
                        </div>
                    </div>

                )
            }
            </I18n>
        )
    }
}

export default TextArea;